module.exports = __webpack_public_path__ + "static/15-a74c214cafb9882f8f7b8c51b99b8282.png";